/**
 * @generated SignedSource<<b388e74d2fb19297a98266b84896f116>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionDescriptionContent_Routine$data = {
  readonly description: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"DescriptionContentFiles_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"DescriptionContentMedia_Media">;
  }>;
  readonly " $fragmentType": "RoutineOccasionDescriptionContent_Routine";
};
export type RoutineOccasionDescriptionContent_Routine$key = {
  readonly " $data"?: RoutineOccasionDescriptionContent_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionDescriptionContent_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionDescriptionContent_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DescriptionContentMedia_Media"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DescriptionContentFiles_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "4e9ce42e0ab197defce49a2ff33fbfc4";

export default node;
